export default __webpack_public_path__ + "static/media/POSISTION_FILL.8c18d41e.png";